<template>
	<div class="graph-nd graph-1d water-graph">
		<svg :viewBox="'0 0 ' + width + ' ' + height" xmlns="http://www.w3.org/2000/svg">
			<Legend v-bind:width="width"
				v-bind:height="height"
				v-bind:startDate="startDate"
				v-bind:bins="bins.length"
				v-bind:binWidth="binWidth">
			</Legend>

			<g v-for="(bin, index) in bins" :key="index"
				class="tooltip-trigger"
				@click="showTooltip(bin, ...arguments)"
				@mouseover="showTooltip(bin, ...arguments)"
				@mouseout="hideTooltip">

				<g v-if="bin.length > 0">
					<circle
						:cx="centerScaleX(index)"
						:cy="scaleY(binTotal(bin)) - 8"
						r="9"
						:style="{ fill: '#ffffff' }">
					</circle>
					<line
						:x1="centerScaleX(index)"
						:x2="centerScaleX(index)"
						:y1="height / 2 + 35"
						:y2="scaleY(binTotal(bin))"
						:style="{ stroke: style.barColor, 'stroke-width': style.barWidth }">
					</line>
					<text
						:x="centerScaleX(index)"
						:y="scaleY(binTotal(bin)) - 5"
						:style="style.barLabelFont"
						text-anchor="middle">
						{{ binTotal(bin) }}
					</text>
				</g>

			</g>
		</svg>

		<Tooltip v-bind:display="tooltipDisplay" @hover="hoverTooltip">
			<p v-for="(point, i) in tooltipBin" :key="i">
				<strong v-if="point.amount">{{ withPrecision(point.amount.value) }} {{ formatGlasses(point.amount.value) }}</strong><br>
				<small>{{ formatDateTime(point.time) }}</small>
			</p>
		</Tooltip>
	</div>
</template>

<script>
import Graph from '.'
import Legend from './component/Legend'

export default {
	name: 'water-graph-1d',
	extends: Graph,

	props: {
		precision: {
			type: Number,
			default: 0
		}
	},

	computed: {
		/**
		 * @function 	bins
		 * @desc 		Bins the data points into day-wide bins for the interval determined by the current scale
		 */
		bins() {
			var bins = []

			for (var t = this.startDate.getTime() ; t <= this.date.getTime() ; t += this.binInterval) {
				bins.push(this.data.filter((point) => (t <= point.time && point.time <= t + this.binInterval)))
			}

			return bins
		},
		barHeight() {
			let max = 8 // default max value

			this.bins.forEach((bin) => {
				if(bin.length > 0) {
					let total = this.binTotal(bin)

					if(total > max)
						max = total
				}
			})

			return max
		},
		displayHeight() {
			return this.height - this.style.padding * 2 - this.style.legendHeight - 30
		},
		legendStart() {
			return this.height - this.style.padding * 2 - this.style.legendHeight
		},
		interval() {
			return this.date.getTime() - this.startDate.getTime()
		},
		binInterval() {
			return this.oneDay * this.binWidth
		}
	},
	methods: {
		setScale(scale) {
			this.scale = scale
		},
		scaleX(x) {
			return x * this.width / this.bins.length
		},
		centerScaleX(x) {
			return (x + 0.5) * this.width / (this.bins.length + 1)
		},
		next() {
			var now = new Date()
			this.date = new Date(this.date.getTime() + this.interval + (this.intevalGap * this.intervalDays))
			if (this.date.getTime() > now.getTime()) {
				this.date = now
			}
		},
		previous() {
			this.date = new Date(this.date.getTime() - this.interval - (this.intevalGap * this.intervalDays))
		},
		binDate(index) {
			return new Date(this.startDate.getTime() + this.binInterval * index)
		},
		/**
		 * @function 	binTotal
		 * @desc 		Returns the sum of the values of each point in a bin.
		 * @param 		{Array} bin
		 */
		binTotal(bin) {
			return bin.map((point) => (point.amount ? point.amount.value : 0)).reduce((a, b) => a + b)
		},
		scaleY(y) {
			return (this.barHeight - y) / this.barHeight * this.displayHeight + this.style.padding
		},
		formatGlasses(count) {
			return (count == 1) ? 'glass' : 'glasses'
		}
	},

	components: {
		Legend
	}
}
</script>

<style lang="scss" scoped>

</style>
